import { render, staticRenderFns } from "./Examinations.vue?vue&type=template&id=234653ac"
import script from "./Examinations.vue?vue&type=script&lang=js"
export * from "./Examinations.vue?vue&type=script&lang=js"
import style0 from "./Examinations.vue?vue&type=style&index=0&id=234653ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports